import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Download, Instagram, Facebook, ArrowLeft, Loader2, Radio, Palette, FileText, GraduationCap, ArrowRight, Gift } from "lucide-react";

const TikTokIcon = (props) => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" {...props}>
    <path d="M16.6 5.82s.51.5 0 0A4.28 4.28 0 0 1 15.54 3h-3.09v12.4a2.59 2.59 0 0 1-2.59 2.5 2.59 2.59 0 0 1 0-5.18c.27 0 .53.04.77.13V9.66a6.04 6.04 0 0 0-.77-.05 5.7 5.7 0 0 0 0 11.4 5.7 5.7 0 0 0 5.7-5.7V8.27a7.34 7.34 0 0 0 4.3 1.38V6.56s-1.44.07-3.06-.74z" />
  </svg>
);

export const VIDEOS = [
  {
    id: "agenciavirtual",
    title: "Agencia de Viajes Virtual",
    desc: "Promo lista para tus campañas — muestra el poder de tener tu propia agencia de viajes 100% virtual.",
    url: "https://customer-assets-jt897jd0.emergentagent.net/job_7d03c1f1-c667-4ac7-8e96-a71fdaaa04a1/artifacts/dkxr51hc_Promo%20Agencia%20de%20Viajes%20Virtual.mp4",
    filename: "Promo Agencia de Viajes Virtual.mp4",
  },
  {
    id: "promointro",
    title: "Promo Intro Club Viajemos",
    desc: "El video de introducción a Club Viajemos — ideal para abrir tus presentaciones y campañas.",
    url: "https://customer-assets.emergentagent.com/job_078cecd6-4392-400b-98ae-d68ce0c16f0e/artifacts/7l50dfyp_WhatsApp%20Video%202026-06-18%20at%2023.00.45.mp4",
    filename: "Promo Intro Club Viajemos.mp4",
  },
  {
    id: "miami",
    title: "Club Viajemos Miami",
    desc: "El comercial de marca que presenta Club Viajemos y engancha desde el primer segundo.",
    url: "https://customer-assets.emergentagent.com/job_078cecd6-4392-400b-98ae-d68ce0c16f0e/artifacts/ks854pdp_Club%20Viajemos%20Miami%20V1.mp4",
    filename: "Club Viajemos Miami V1.mp4",
  },
  {
    id: "nino",
    title: "Hay un Niño que Sueña",
    desc: "El comercial emocional que vende el sueño de viajar y conecta con tu audiencia.",
    url: "https://customer-assets.emergentagent.com/job_078cecd6-4392-400b-98ae-d68ce0c16f0e/artifacts/vmj3fsfd_Club%20Viajemos%20Hay%20un%20nin%CC%83o%20que%20Suen%CC%83a%20%282%29.mp4",
    filename: "Club Viajemos - Hay un nino que suena.mp4",
  },
  {
    id: "dividelo",
    title: "Divídelo.com",
    desc: "El comercial de financiamiento: paga tu viaje en cuotas, sin excusas para no viajar.",
    url: "https://customer-assets.emergentagent.com/job_078cecd6-4392-400b-98ae-d68ce0c16f0e/artifacts/ft82erq0_Dividelo.com.mp4",
    filename: "Dividelo.com.mp4",
  },
  {
    id: "invitadosvip",
    title: "Invitados VIP",
    desc: "El comercial para invitar prospectos a tus eventos VIP y llenar tus citas.",
    url: "https://customer-assets.emergentagent.com/job_078cecd6-4392-400b-98ae-d68ce0c16f0e/artifacts/dtd8kno6_Invitados%20VIP.mp4",
    filename: "Invitados VIP.mp4",
  },
  {
    id: "comercial5",
    title: "Comercial Club Viajemos",
    desc: "Nuevo comercial para tus redes — listo para publicar y compartir.",
    url: "https://customer-assets.emergentagent.com/job_078cecd6-4392-400b-98ae-d68ce0c16f0e/artifacts/4jgeyhyv_WhatsApp%20Video%202026-06-18%20at%2023.00.50.mp4",
    filename: "Comercial Club Viajemos.mp4",
  },
  {
    id: "webinar",
    title: "Bienvenido al Webinar",
    desc: "El video de bienvenida para abrir tus webinars y recibir a tus invitados.",
    url: "https://customer-assets.emergentagent.com/job_078cecd6-4392-400b-98ae-d68ce0c16f0e/artifacts/xttd49gq_WhatsApp%20Video%202026-06-18%20at%2023.06.17%20%281%29.mp4",
    filename: "Bienvenido al Webinar.mp4",
  },
  {
    id: "agencia24h",
    title: "Abre tu Agencia en Menos de 24 Horas",
    desc: "El comercial directo que muestra lo rápido que cualquiera puede tener su propia agencia de viajes.",
    url: "https://customer-assets.emergentagent.com/job_30edb56d-28ed-4b9d-9fb8-8fa5490ec6fa/artifacts/d0t9xa97_01%20Abre%20tu%20agencia%20en%20menos%20de%2024%20horas.mp4",
    filename: "01 Abre tu agencia en menos de 24 horas.mp4",
  },
  {
    id: "agenciaabierta",
    title: "3, 2, 1... Tu Agencia de Viajes Abierta",
    desc: "Cuenta regresiva que genera urgencia: tu agencia lista en segundos. Ideal para enganchar en redes.",
    url: "https://customer-assets.emergentagent.com/job_30edb56d-28ed-4b9d-9fb8-8fa5490ec6fa/artifacts/pf1cnbsj_02%203%2C2%2C1%20Tu%20agencia%20de%20viajes%20abierta.mp4",
    filename: "02 3,2,1 Tu agencia de viajes abierta.mp4",
  },
  {
    id: "ayersonando",
    title: "Ayer Soñando, Hoy con tu Agencia de Viajes",
    desc: "Comercial emocional de transformación: del sueño a la realidad de tener tu propio negocio de viajes.",
    url: "https://customer-assets.emergentagent.com/job_30edb56d-28ed-4b9d-9fb8-8fa5490ec6fa/artifacts/uxuuhigy_03%20Ayer%20son%CC%83ando%20hoy%20con%20tu%20agencia%20de%20viajes.mp4",
    filename: "03 Ayer sonando hoy con tu agencia de viajes.mp4",
  },
  {
    id: "bastadesonar",
    title: "Basta de Soñar",
    desc: "Llamado a la acción que motiva a dar el paso y dejar de postergar el sueño de viajar y emprender.",
    url: "https://customer-assets.emergentagent.com/job_30edb56d-28ed-4b9d-9fb8-8fa5490ec6fa/artifacts/zyxwjijm_04.%20Basta%20de%20son%CC%83ar.mp4",
    filename: "04 Basta de sonar.mp4",
  },
  {
    id: "sinoficina",
    title: "Sin Oficina, Sin Experiencia, Sin Esperar",
    desc: "Rompe las excusas: muestra que no necesitas oficina ni experiencia para empezar tu agencia hoy.",
    url: "https://customer-assets.emergentagent.com/job_30edb56d-28ed-4b9d-9fb8-8fa5490ec6fa/artifacts/5h0pg8jr_05%20Sin%20oficina%2C%20sin%20experiencia%2C%20sin%20esperar.mp4",
    filename: "05 Sin oficina, sin experiencia, sin esperar.mp4",
  },
  {
    id: "valorexperiencia",
    title: "El Valor de Toda la Experiencia",
    desc: "Resalta todo lo que incluye la experiencia Club Viajemos — perfecto para comunicar el valor real de la oportunidad.",
    url: "https://customer-assets.emergentagent.com/job_f0a54056-0d1c-4700-ad08-8557dfe95848/artifacts/ybrxrise_06%20Valor%20de%20toda%20la%20experiencia%20%281%29.mp4",
    filename: "06 Valor de toda la experiencia.mp4",
  },
  {
    id: "travelempire",
    title: "Travel Empire y Club Viajemos",
    desc: "El comercial que presenta Travel Empire y Club Viajemos — perfecto para mostrar la oportunidad completa.",
    url: "https://customer-assets.emergentagent.com/job_30edb56d-28ed-4b9d-9fb8-8fa5490ec6fa/artifacts/7iazvnd4_Travel%20Empire%20y%20Club%20Viajemos%20%281%29.mp4",
    filename: "Travel Empire y Club Viajemos.mp4",
  },
  {
    id: "algoencomun",
    title: "Tenemos Algo en Común",
    desc: "Comercial cercano que conecta con tu audiencia desde la empatía — ideal para romper el hielo y generar confianza.",
    url: "https://customer-assets.emergentagent.com/job_30edb56d-28ed-4b9d-9fb8-8fa5490ec6fa/artifacts/gixz78zl_07%20Tenemos%20algo%20en%20comun.mp4",
    filename: "07 Tenemos algo en comun.mp4",
  },
  {
    id: "webinarmiercoles",
    title: "Te Invito a mi Webinar (todos los miércoles)",
    desc: "Invitación directa a tu webinar semanal de los miércoles — ideal para llenar tus sesiones en vivo.",
    url: "https://customer-assets.emergentagent.com/job_f0a54056-0d1c-4700-ad08-8557dfe95848/artifacts/92objamj_08%20Te%20invito%20a%20mi%20webinar%20todos%20los%20miercoles%20%281%29.mp4",
    filename: "08 Te invito a mi webinar todos los miercoles.mp4",
  },
  {
    id: "noesparatodos",
    title: "Lo que Viste Hoy No es Para Todo el Mundo",
    desc: "Comercial de filtro y exclusividad: genera deseo y compromiso en quienes sí están listos para la oportunidad.",
    url: "https://customer-assets.emergentagent.com/job_f0a54056-0d1c-4700-ad08-8557dfe95848/artifacts/q2hd65uf_09%20Lo%20que%20viste%20hoy%20no%20es%20para%20todo%20el%20mundo.mp4",
    filename: "09 Lo que viste hoy no es para todo el mundo.mp4",
  },
  {
    id: "sonarvsconstruir",
    title: "La Diferencia entre Soñar y Construir un Negocio de Turismo",
    desc: "Marca la diferencia entre quienes solo sueñan y quienes de verdad construyen su negocio de turismo — ideal para inspirar acción.",
    url: "https://customer-assets.emergentagent.com/job_f0a54056-0d1c-4700-ad08-8557dfe95848/artifacts/09q1xcr9_13%20Diferencia%20entre%20Son%CC%83ar%20y%20Construir%20un%20negocio%20de%20turismo.mp4",
    filename: "13 Diferencia entre Sonar y Construir un negocio de turismo.mp4",
  },
];

const KIT_MARKETING = [
  {
    id: "kit-manual-marca",
    title: "Manual de Marca Club Viajemos",
    desc: "Guía oficial de marca: lineamientos, identidad visual y uso correcto del logotipo. Descárgalo para tus diseños y campañas.",
    url: "https://customer-assets.emergentagent.com/job_f0a54056-0d1c-4700-ad08-8557dfe95848/artifacts/ja7dnu8a_MANUAL%20CLUB%20VIAJEMOS%20%281%29%20%281%29.pdf",
    filename: "Manual Club Viajemos.pdf",
  },
];

const TSHIRT_DESIGNS = [
  { file: "tshirt-frente-1.jpg", label: "Frente · ES", orig: "Diseno Playera Frente (ES).jpg" },
  { file: "tshirt-reverso-1.jpg", label: "Reverso · ES", orig: "Diseno Playera Reverso (ES).jpg" },
  { file: "tshirt-frente-2.jpg", label: "Frente · EN", orig: "Diseno Playera Frente (EN).jpg" },
  { file: "tshirt-reverso-2.jpg", label: "Reverso · EN", orig: "Diseno Playera Reverso (EN).jpg" },
];

const PlatformBadges = () => (
  <div className="flex items-center gap-2">
    {[
      { Icon: Instagram, label: "Instagram" },
      { Icon: Facebook, label: "Facebook" },
      { Icon: TikTokIcon, label: "TikTok" },
    ].map(({ Icon, label }) => (
      <span key={label} title={label} className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-white/10 border border-white/15 text-white/80">
        <Icon />
      </span>
    ))}
  </div>
);

const VideosQueHacenDinero = () => {
  const [downloading, setDownloading] = useState(null);
  const [designs, setDesigns] = useState([]);

  useEffect(() => {
    fetch("/kit-marketing/manifest.json")
      .then((r) => r.json())
      .then((data) => setDesigns(Array.isArray(data) ? data : []))
      .catch(() => setDesigns([]));
  }, []);

  const handleDownload = async (v) => {
    setDownloading(v.id);
    try {
      const res = await fetch(v.url);
      const blob = await res.blob();
      const href = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = href;
      a.download = v.filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(href);
    } catch {
      window.open(v.url, "_blank");
    } finally {
      setDownloading(null);
    }
  };

  return (
    <div data-testid="videos-money-page" className="min-h-screen bg-[#0a0e1a]">
      {/* Header */}
      <header className="border-b border-white/10 sticky top-0 z-50 bg-[#0a0e1a]/95 backdrop-blur">
        <div className="max-w-6xl mx-auto px-4 py-3 flex items-center gap-3">
          <Link to="/" className="flex items-center gap-1 text-slate-400 hover:text-white text-sm font-medium">
            <ArrowLeft className="h-4 w-4" /> Inicio
          </Link>
        </div>
      </header>

      {/* Hero */}
      <section className="relative overflow-hidden border-b border-white/10">
        <div className="absolute inset-0 bg-gradient-to-br from-[#80C753]/10 via-transparent to-[#45A0EE]/10" aria-hidden="true" />
        <div className="relative max-w-6xl mx-auto px-4 py-12 md:py-16 text-center">
          <div className="inline-flex items-center gap-2 bg-red-600/90 text-white px-3 py-1.5 rounded-full text-xs font-black uppercase tracking-wider mb-4">
            <span className="relative flex h-2.5 w-2.5">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75" />
              <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-white" />
            </span>
            Comerciales en vivo hoy
          </div>
          <h1 className="text-3xl md:text-5xl font-black text-white leading-tight mb-4">
            Videos que <span className="text-[#80C753]">hacen dinero</span>
          </h1>
          <p className="text-slate-300 text-base md:text-lg max-w-2xl mx-auto mb-5">
            Estos son los comerciales que están funcionando ahora mismo en redes. Úsalos y descárgalos para tus campañas.
          </p>
          <div className="inline-flex items-center gap-3 text-slate-400 text-sm">
            <span className="font-semibold text-white/80">Funcionando en:</span>
            <PlatformBadges />
          </div>
        </div>
      </section>

      {/* Videos Grid */}
      <section className="max-w-6xl mx-auto px-4 py-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {VIDEOS.map((v) => (
            <div key={v.id} data-testid={`video-card-${v.id}`} className="bg-[#11162a] rounded-2xl border border-white/10 overflow-hidden flex flex-col hover:border-[#80C753]/40 transition-colors">
              <div className="relative bg-black">
                <span className="absolute top-3 left-3 z-10 inline-flex items-center gap-1.5 bg-red-600 text-white px-2.5 py-1 rounded-full text-[10px] font-black uppercase tracking-wider shadow">
                  <Radio className="h-3 w-3" /> En vivo
                </span>
                <video
                  data-testid={`video-player-${v.id}`}
                  src={v.url}
                  controls
                  playsInline
                  preload="metadata"
                  className="w-full aspect-[9/16] max-h-[460px] object-contain bg-black"
                />
              </div>
              <div className="p-5 flex flex-col flex-1">
                <div className="flex items-center justify-between gap-2 mb-2">
                  <h3 className="text-white font-black text-lg leading-tight">{v.title}</h3>
                  <PlatformBadges />
                </div>
                <p className="text-slate-400 text-sm mb-4 flex-1">{v.desc}</p>
                <button
                  type="button"
                  data-testid={`download-${v.id}`}
                  onClick={() => handleDownload(v)}
                  disabled={downloading === v.id}
                  className="w-full inline-flex items-center justify-center gap-2 bg-[#80C753] hover:bg-[#6fb145] text-white font-bold px-4 py-3 rounded-xl text-sm uppercase tracking-wide disabled:opacity-60 transition-colors"
                >
                  {downloading === v.id ? (
                    <><Loader2 className="h-4 w-4 animate-spin" /> Descargando...</>
                  ) : (
                    <><Download className="h-4 w-4" /> Descargar comercial</>
                  )}
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Cursos de cada Secreto */}
      <section className="max-w-6xl mx-auto px-4 pt-4" data-testid="comunidad-cursos-section">
        <div className="text-center mb-6">
          <div className="inline-flex items-center gap-2 bg-[#C9A84C]/15 border border-[#C9A84C]/40 text-[#C9A84C] px-3 py-1.5 rounded-full text-xs font-black uppercase tracking-wider mb-3">
            <GraduationCap className="h-4 w-4" /> Universidad Travel Empire
          </div>
          <h2 className="text-2xl md:text-4xl font-black text-white leading-tight mb-2">
            Cursos de cada <span className="text-[#C9A84C]">Secreto</span>
          </h2>
          <p className="text-slate-300 text-sm md:text-base max-w-2xl mx-auto">
            Un curso profesional por cada Secreto del sistema — guiones reales, objeciones con cierre y certificación.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {[
            { href: "/cursoelpaquetedelmillon", badge: "SECRETO #1 · EL PAQUETE DEL MILLÓN", title: "Certificados de Viaje", sub: "Pitch perfecto · método de los 3 círculos · 8 objeciones con cierre · plan 90 días" },
            { href: "/cursovisaconexito", badge: "SECRETO #2 · VISA CON ÉXITO", title: "Asesorías Migratorias", sub: "7 preguntas de descubrimiento · 5 ventajas · 10 objeciones con cierre · referidos" },
            { href: "/cursoacademiab2b", badge: "SECRETO #3 · ACADEMIA B2B · CERTIFICACIÓN", title: "Plataforma B2B RateHawk", sub: "RateHawk · sub-agencias · cotización profesional · examen final + sello" },
            { href: "/cursoclubvacacional", badge: "SECRETO #4 · 12 LECCIONES", title: "Club Vacacional", sub: "Proceso de 15 pasos · venta online y presencial · 8 objeciones · certificado final" },
            { href: "/cursoreferidos", badge: "SECRETO #5 · EL PODER DE REFERIR", title: "Embajador Digital", sub: "8 módulos · URL Hotmart · 2 salas semanales · regla del 25% · calculadora de ganancias" },
            { href: "/curso-gohighlevel-clubviajemos.html", badge: "app.viajemos.us", title: "https://app.viajemos.us para Agentes", sub: "Automatiza tu negocio · embudos, CRM y citas con https://app.viajemos.us paso a paso", external: true },
          ].map((curso) => (
            <a
              key={curso.href}
              href={curso.href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`comunidad-curso-${curso.href.replace(/[^a-z0-9]/gi, "-").toLowerCase()}`}
              className="group block bg-gradient-to-br from-[#0D1B2A] via-[#1B263B] to-[#0D1B2A] border-2 border-[#C9A84C]/40 hover:border-[#C9A84C] rounded-xl p-5 transition-all hover:shadow-[0_10px_40px_rgba(201,168,76,0.25)] hover:scale-[1.01]"
            >
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-xl bg-[#C9A84C]/20 border border-[#C9A84C]/40 flex items-center justify-center flex-shrink-0">
                  <GraduationCap className="h-6 w-6 text-[#C9A84C]" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-[10px] text-[#C9A84C] font-mono tracking-[2px] uppercase mb-1">{curso.badge}</p>
                  <h4 className="text-base sm:text-lg font-bold text-white leading-tight mb-1">{curso.title}</h4>
                  <p className="text-xs sm:text-sm text-slate-300 leading-snug">{curso.sub}</p>
                </div>
                <div className="flex items-center gap-1 text-[#C9A84C] font-bold text-xs uppercase tracking-wider flex-shrink-0 group-hover:gap-2 transition-all">
                  <span className="hidden sm:inline">Abrir curso</span>
                  <ArrowRight className="h-4 w-4" />
                </div>
              </div>
            </a>
          ))}
        </div>
      </section>

      {/* Manual completo + Bonus $500 */}
      <section className="max-w-6xl mx-auto px-4 pt-6" data-testid="comunidad-manual-section">
        <a
          href="/manual27"
          data-testid="comunidad-cta-manual27"
          className="group flex items-center justify-between gap-4 bg-gradient-to-r from-[#1a1428] via-[#2a2018] to-[#1a1428] hover:from-[#2a2018] hover:to-[#1a1428] border border-amber-400/40 hover:border-amber-400/70 rounded-xl px-5 py-4 transition-all shadow-lg hover:shadow-[0_10px_40px_rgba(212,175,55,0.2)]"
        >
          <div className="flex items-center gap-3 min-w-0">
            <div className="w-11 h-11 rounded-lg bg-amber-400/20 border border-amber-400/40 flex items-center justify-center flex-shrink-0">
              <Gift className="h-5 w-5 text-amber-300" />
            </div>
            <div className="min-w-0">
              <p className="text-[10px] text-amber-300 font-mono uppercase tracking-[2px] mb-0.5">MANUAL COMPLETO + BONUS $500 USD</p>
              <p className="text-white font-bold text-sm sm:text-base truncate">Manual de 252 páginas + Protocolo 2026 <span className="text-slate-400 font-normal">— y $500 USD de regalo</span></p>
              <p className="text-slate-400 text-xs truncate hidden sm:block">Entregado en tu reunión virtual con un agente exitoso</p>
            </div>
          </div>
          <span className="flex items-center gap-1 text-amber-300 text-xs font-bold uppercase tracking-wider flex-shrink-0 group-hover:gap-2 transition-all">
            Ver <ArrowRight className="h-4 w-4" />
          </span>
        </a>
      </section>

      {/* Kit de Marketing */}
      <section className="max-w-6xl mx-auto px-4 pb-14">
        <div className="border-t border-white/10 pt-10">
          <div className="text-center mb-8">
            <div className="inline-flex items-center gap-2 bg-[#45A0EE]/20 text-[#45A0EE] px-3 py-1.5 rounded-full text-xs font-black uppercase tracking-wider mb-3">
              <Palette className="h-3.5 w-3.5" /> Diseños
            </div>
            <h2 className="text-2xl md:text-4xl font-black text-white leading-tight mb-3">
              Kit de <span className="text-[#45A0EE]">Marketing</span>
            </h2>
            <p className="text-slate-300 text-base max-w-2xl mx-auto">
              Material y piezas de diseño listas para tus campañas. Descárgalas y compártelas con tu comunidad.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {KIT_MARKETING.map((v) => (
              <div key={v.id} data-testid={`kit-card-${v.id}`} className="bg-[#11162a] rounded-2xl border border-white/10 overflow-hidden flex flex-col hover:border-[#45A0EE]/40 transition-colors">
                <div className="relative bg-gradient-to-br from-[#45A0EE]/25 to-[#11162a] aspect-[9/16] max-h-[460px] flex flex-col items-center justify-center gap-4">
                  <span className="absolute top-3 left-3 z-10 inline-flex items-center gap-1.5 bg-[#45A0EE] text-white px-2.5 py-1 rounded-full text-[10px] font-black uppercase tracking-wider shadow">
                    <Palette className="h-3 w-3" /> Diseño
                  </span>
                  <div className="w-24 h-24 rounded-2xl bg-white/10 border border-white/15 flex items-center justify-center">
                    <FileText className="h-12 w-12 text-[#45A0EE]" />
                  </div>
                  <span className="text-white/60 text-xs font-bold uppercase tracking-widest">PDF · Manual</span>
                </div>
                <div className="p-5 flex flex-col flex-1">
                  <div className="flex items-center justify-between gap-2 mb-2">
                    <h3 className="text-white font-black text-lg leading-tight">{v.title}</h3>
                    <PlatformBadges />
                  </div>
                  <p className="text-slate-400 text-sm mb-4 flex-1">{v.desc}</p>
                  <button
                    type="button"
                    data-testid={`download-${v.id}`}
                    onClick={() => handleDownload(v)}
                    disabled={downloading === v.id}
                    className="w-full inline-flex items-center justify-center gap-2 bg-[#45A0EE] hover:bg-[#3a8cd4] text-white font-bold px-4 py-3 rounded-xl text-sm uppercase tracking-wide disabled:opacity-60 transition-colors"
                  >
                    {downloading === v.id ? (
                      <><Loader2 className="h-4 w-4 animate-spin" /> Descargando...</>
                    ) : (
                      <><Download className="h-4 w-4" /> Descargar material</>
                    )}
                  </button>
                </div>
              </div>
            ))}
          </div>

          {/* Diseños de Playera / T-Shirt */}
          <div className="mt-10">
            <div className="flex items-center justify-between gap-3 mb-5 flex-wrap">
              <h3 className="text-white font-black text-xl">Diseños de Playera o T-Shirt</h3>
              <p className="text-slate-400 text-sm">Frente y reverso, en español e inglés. Toca para descargar.</p>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4" data-testid="tshirt-designs">
              {TSHIRT_DESIGNS.map((d, i) => {
                const item = { id: `tshirt-${i}`, url: `/kit-marketing/${d.file}`, filename: d.orig };
                return (
                  <button
                    key={d.file}
                    type="button"
                    data-testid={`tshirt-${i}`}
                    onClick={() => handleDownload(item)}
                    disabled={downloading === item.id}
                    className="group relative rounded-xl overflow-hidden border border-white/10 bg-white hover:border-[#45A0EE]/50 transition-colors flex flex-col"
                  >
                    <div className="aspect-square bg-white flex items-center justify-center p-2">
                      <img src={`/kit-marketing/${d.file}`} alt={d.label} loading="lazy" className="max-w-full max-h-full object-contain transition-transform duration-300 group-hover:scale-105" />
                    </div>
                    <span className="absolute top-2 left-2 bg-[#45A0EE] text-white text-[10px] font-black uppercase tracking-wide px-2 py-0.5 rounded-full">{d.label}</span>
                    <span className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                      {downloading === item.id ? (
                        <Loader2 className="h-6 w-6 text-[#45A0EE] animate-spin" />
                      ) : (
                        <Download className="h-6 w-6 text-white opacity-0 group-hover:opacity-100 transition-opacity drop-shadow" />
                      )}
                    </span>
                  </button>
                );
              })}
            </div>
          </div>

          {/* Galería de diseños */}
          {designs.length > 0 && (
            <div className="mt-10">
              <div className="flex items-center justify-between gap-3 mb-5 flex-wrap">
                <h3 className="text-white font-black text-xl">Posts y diseños de venta <span className="text-slate-400 font-medium text-base">({designs.length})</span></h3>
                <p className="text-slate-400 text-sm">Toca cualquier diseño para descargarlo.</p>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
                {designs.map((d, i) => {
                  const item = { id: `design-${i}`, url: `/kit-marketing/${d.file}`, filename: d.orig };
                  return (
                    <button
                      key={d.file}
                      type="button"
                      data-testid={`design-${i}`}
                      onClick={() => handleDownload(item)}
                      disabled={downloading === item.id}
                      className="group relative rounded-xl overflow-hidden border border-white/10 bg-[#11162a] hover:border-[#45A0EE]/50 transition-colors aspect-square"
                    >
                      <img
                        src={`/kit-marketing/${d.file}`}
                        alt={d.orig}
                        loading="lazy"
                        className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                      />
                      <span className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors flex items-center justify-center">
                        {downloading === item.id ? (
                          <Loader2 className="h-6 w-6 text-white animate-spin" />
                        ) : (
                          <Download className="h-6 w-6 text-white opacity-0 group-hover:opacity-100 transition-opacity" />
                        )}
                      </span>
                    </button>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default VideosQueHacenDinero;
